import { isEmpty } from "lodash";
import { ErrorAlert } from "./Alerts";
import { t } from "i18next";

const getError = (error, fallbackMessageKey = "unhandledExceptionRequest") => {
    if (isEmpty(error)) {
        return t(fallbackMessageKey);
    }

    if (typeof error !== "string" && error?.length) {
        return error[0];
    }

    return error;
};

const responseStateMachine = (response) => {
    let result = null;
    let message = null;
    switch (response.status) {
        case 200:
        case 201:
        case 202:
        case 204:
            result = response?.data;
            break;
        case 401:
            if (
                response?.data?.path !== "/notifications/custom-token" ||
                response?.data?.path !== "/notifications/last-seen"
            ) {
                ErrorAlert(
                    "Your session has expired! please refresh your page."
                );
                window.location.reload();
            }
            break;
        case 409:
            result = { conflict: true, ...(response?.data || {}) };
            break;
        case 410:
            result = { expired: true };
            break;
        case 404:
            ErrorAlert(t("notFoundRequest"));
            break;
        case 400:
            message = getError(response?.data?.message, "invalidRequest");
            ErrorAlert(message);
            break;
        default:
            if (
                response?.data?.path !== "/notifications/custom-token" ||
                response?.data?.path !== "/notifications/last-seen"
            )
                ErrorAlert(getError(response?.data?.message));
            break;
    }

    return result;
};

export { responseStateMachine };
